import { useState, useEffect, ChangeEvent } from 'react';
import { Input } from '@/components/ui/input';
import { useTranslation } from 'react-i18next';

interface BeerStyle {
  name: string;
  value: string;
}

export default function BeerCarbonation() {
  const { t } = useTranslation();
  const [data, setData] = useState<BeerStyle[]>([]);
  const [filteredData, setFilteredData] = useState<BeerStyle[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetch("/api/beerstyles")
      .then(res => res.json())
      .then((result: BeerStyle[]) => {
        setData(result);
        setFilteredData(result);
        setIsLoaded(true);
      })
      .catch((err: Error) => {
        setError(err);
        setIsLoaded(true);
      });
  }, []);

  function handleOnChange(event: ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    setSearch(value);
    setFilteredData(data.filter(el => el.name.toLowerCase().includes(value.toLowerCase())));
  }

  if (error) return <p className="text-destructive text-sm">{t('common.error', { message: error.message })}</p>;
  if (!isLoaded) return <p className="text-muted-foreground text-sm">{t('common.loading')}</p>;

  return (
    <div>
      <Input
        placeholder={t('carbonation.searchStyle')}
        value={search}
        onChange={handleOnChange}
        className="mb-3"
      />
      <div className="overflow-x-auto">
        <table className="w-full text-sm border border-border rounded-md overflow-hidden">
          <thead className="bg-muted text-muted-foreground">
            <tr>
              <th className="px-3 py-2 text-left font-medium">{t('carbonation.styleNameCol')}</th>
              <th className="px-3 py-2 text-left font-medium">{t('carbonation.carbonationCol')}</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, idx) => (
              <tr key={idx} className="border-t border-border hover:bg-accent/30 transition-colors">
                <td className="px-3 py-1.5">{item.name}</td>
                <td className="px-3 py-1.5">{item.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
